import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "aos/dist/aos.css";
import { FaFacebook } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoLinkedin } from "react-icons/io5";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import Slider1 from "../img/1.jpg";
import Slider2 from "../img/2.jpg";
import Slider3 from "../img/3.jpg";
import Slider4 from "../img/4.jpg";
import Slider5 from "../img/5.jpg";
import Slider6 from "../img/6.jpg";
import Slider7 from "../img/7.jpg";
import Slider8 from "../img/8.jpg";
import Slider9 from "../img/9.jpg";
import Slider10 from "../img/10.jpg";
import Slider11 from "../img/11.jpg";
import Slider12 from "../img/12.jpg";
import Slider13 from "../img/13.jpg";
import Slider14 from "../img/14.jpg";
import Slider15 from "../img/15.jpg";
import Slider16 from "../img/16.jpg";
import Slider17 from "../img/17.jpg";
import Slider18 from "../img/18.jpg";
import Slider19 from "../img/19.jpg";

import { Link } from "react-router-dom";

const Slider = () => {
  // Create state variables for the index and image array
  const [index, setIndex] = useState(0);
  const [index1, setIndex1] = useState(0);
  const images = [
    Slider1,
    Slider2,
    Slider3,
    Slider4,
    Slider5,
    Slider6,
    Slider7,
    Slider8,
    Slider9,
    Slider10,
     Slider11,
    Slider12,
    Slider13,
    Slider14,
    Slider15,
    Slider16,
    Slider17,
    Slider18,
    Slider19,
  ];

  const content2 = [
    "Best Urologist in the North Bihar",
    "Over 14000 Operation Done Successfully",
    "Over 70 OPD Daily",
    "Most Awarded Doctor in North Bihar",
    "Ex-Urologist at IGIMS, Patna"
  ];

  // Use useEffect to increment the index and update the image every 5 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
      setIndex1((prevIndex) => (prevIndex + 1) % content2.length);
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);

  // Handle manual navigation with boundary checks
  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Render the current image
  return (
    <CarouselContainer>
      <ImageDiv>
        <LeftButton onClick={prevSlide} aria-label="Previous slide">
          <BsChevronLeft />
        </LeftButton>
        <ImageWrapper>
          <SlidingImg
            src={images[index]}
            alt="Slider Image G D Goenka Public School, Darbhanga"
          />
        </ImageWrapper>
        <RightButton onClick={nextSlide} aria-label="Next slide">
          <BsChevronRight />
        </RightButton>
      </ImageDiv>
      
      <SocialMediaIconsDiv>
        <IconWrapper>
          <Link
            to="https://www.facebook.com/erajaythakur007/"
            target="_blank"
            aria-label="Facebook"
          >
            <FaFacebook />
          </Link>
        </IconWrapper>
        <IconWrapper>
          <Link
            to="https://www.youtube.com/@srksoftwares"
            target="_blank"
            aria-label="YouTube"
          >
            <IoLogoYoutube />
          </Link>
        </IconWrapper>
        <IconWrapper>
          <Link
            to="https://www.instagram.com/srksoftwares"
            target="_blank"
            aria-label="Instagram"
          >
            <FaInstagramSquare />
          </Link>
        </IconWrapper>
        <IconWrapper>
          <Link
            to="https://www.linkedin.com/in/meetajaythakur007"
            target="_blank"
            aria-label="LinkedIn"
          >
            <IoLogoLinkedin />
          </Link>
        </IconWrapper>
      </SocialMediaIconsDiv>
    </CarouselContainer>
  );
};

export default Slider;

// Styled Components
const CarouselContainer = styled.div`
  position: relative;
  width: 100vw;
  height:auto;
  overflow: hidden;
`;

const ImageDiv = styled.div`
  position: relative;
  width: 100vw;
  height: auto;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  
  @media (max-width: 768px) {
    padding-top: 56.25%; /* 4:3 Aspect Ratio for tablets */
  }
  
  @media (max-width: 480px) {
    padding-top: 56.25%; /* 1:1 Aspect Ratio for mobile */
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const SlidingImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.9);
  }
  
  @media (max-width: 768px) {
    width: 35px;
    height: 35px;
  }
  
  @media (max-width: 480px) {
    width: 30px;
    height: 30px;
  }
`;

const LeftButton = styled(NavigationButton)`
  left: 15px;
  
  @media (max-width: 480px) {
    left: 10px;
  }
`;

const RightButton = styled(NavigationButton)`
  right: 15px;
  
  @media (max-width: 480px) {
    right: 10px;
  }
`;

const SocialMediaIconsDiv = styled.div`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 10;
  
  @media (max-width: 1024px) {
    right: 15px;
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    top: auto;
    bottom: 20px;
    right: 50%;
    transform: translateX(50%);
    flex-direction: row;
    gap: 20px;
  }
  
  @media (max-width: 480px) {
    bottom: 15px;
    gap: 15px;
  }
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  border: 2px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
  }
  
  a {
    color: #fff;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  
  @media (max-width: 1024px) {
    width: 45px;
    height: 45px;
    
    a {
      font-size: 22px;
    }
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    
    a {
      font-size: 20px;
    }
  }
  
  @media (max-width: 480px) {
    width: 35px;
    height: 35px;
    
    a {
      font-size: 18px;
    }
  }
`;

// Keeping your other styled components for reference (they're not used in the current JSX but might be needed elsewhere)
const OverText = styled.div`
  position: absolute;
  top: 10%;
  left: 15%;
  font-size: clamp(2rem, 5vw, 6rem);
  color: #fff;
  font-family: cursive;
  z-index: 5;
  
  @media (max-width: 768px) {
    left: 10%;
    top: 15%;
  }
  
  @media (max-width: 480px) {
    left: 5%;
    top: 20%;
    font-size: clamp(1.5rem, 6vw, 3rem);
  }
`;

const HyperLink = styled(Link)`
  text-decoration: none;
  color: #050572;
  font-weight: 500;
  background: #ddd;
  color: red;
  margin-top: 1em;
  padding: 10px 30px;
  font-size: clamp(1rem, 2vw, 1.4rem);
  font-weight: 600;
  border-radius: 30px;
  border: none;
  
  &:hover {
    background: red;
    color: white;
    transition: all 0.5s ease-in-out;
  }
`;

const WelcomeText = styled.p`
  margin-bottom: 0;
  background: #fff;
  border-radius: 25px;
  padding: 10px 20px;
  color: blue;
  font-size: clamp(1rem, 3vw, 2rem);
  font-weight: 600;
`;

const BookNowButtom = styled.button`
  background: #ddd;
  color: red;
  margin-top: 1em;
  padding: 10px 30px;
  font-size: clamp(1rem, 2vw, 1.5rem);
  font-weight: 600;
  border-radius: 30px;
  border: none;
  
  &:hover {
    background: red;
    color: white;
    transition: all 0.5s ease-in-out;
  }
`;

const MaskLayer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #000;
  opacity: 0.8;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2;
`;

const BookigContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-left: 4%;
  padding-right: 4%;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const BookAppointment = styled.div`
  border-radius: 10px;
  width: 50vw;
  height: auto;
  background-color: rgb(18, 150, 156);
  padding: 1rem;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    width: 90vw;
    margin-top: 1rem;
  }
`;